class ComplementaryVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.formId = null;
    this.currentVariant = null;
    this.options = [];
    this.variantData = [];
    this.onVariantChange = this.onVariantChange.bind(this);
    this.handleSwatchHover = this.handleSwatchHover.bind(this);
  }

  connectedCallback() {

    try {
      const scriptContent = this.querySelector('script');
      this.variantData = JSON.parse(scriptContent?.textContent || '[]');
      console.log('Variant data parsed: ', this.variantData);
    } catch (error) {
      console.error('Variant data parse error:', error);
    }
    this.formId = this.getAttribute('form-id');
    this.addEventListener('change', this.onVariantChange);
    
    this.addEventListener('click', (e) => {
      const swatch = e.target.closest('.swatch-option');
      if (!swatch) return;
      
      const input = swatch.querySelector('input[type="radio"]');
      if (!input) return;

      // Manually trigger change event if needed
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.updateSelectionMetadata({ target: input });

    });

    this.initializeSwatches();
    this.updateOptions();
    this.updateMasterId();
    this.updateFormInputs();
    
  }

  initializeSwatches() {
    this.querySelectorAll('.swatch-option').forEach(swatch => {
      const input = swatch.querySelector('input[type="radio"]');
      swatch.classList.toggle('selected', input?.checked);
    });
  }

  handleSwatchHover(event) {
    const swatch = event.currentTarget;
    const mediaId = swatch.querySelector('input[type="radio"]')?.dataset?.variantMedia;
    if (!mediaId) return;
    const mediaContainer = swatch.closest('.product-card-wrapper')?.querySelector('.media--hover-effect');
    if (!mediaContainer) return;
    const mainImage = mediaContainer.querySelector('.main-product-image');
    if (mainImage) mainImage.classList.remove('active');
    const variantImage = mediaContainer.querySelector(`.variant-image[data-variant-id="${mediaId}"]`);
    if (variantImage) {
      const allVariantImages = mediaContainer.querySelectorAll('.variant-image');
      allVariantImages.forEach(img => img.classList.remove('active'));
      variantImage.classList.add('active');
    }
  }

  handleSwatchClick(swatch) {
    const input = swatch.querySelector('input[type="radio"]');
    if (!input) return;
    
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // Force UI update
    this.updateSelectionMetadata({ target: input });
  }

  disconnectedCallback() {
    const swatchOptions = this.querySelectorAll('.swatch-option');
    swatchOptions.forEach(swatch => {
      swatch.removeEventListener('mouseenter', this.handleSwatchHover);
    });
    this.removeEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    if (!event.target.matches('input[type="radio"]')) return;

    // Update selected state
    const group = event.target.closest('.swatch-options');
    if (group) {
      group.querySelectorAll('.swatch-option').forEach(swatch => {
        swatch.classList.remove('selected');
      });
      event.target.closest('.swatch-option').classList.add('selected');
    }

    // Process changes
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia(event);
    this.updateFormInputs();
    this.updateSelectionMetadata(event);
    console.log(group);
    console.log('hi');
    const swatch = event.target.closest('.swatch-option');
    if (swatch) {
      const isAvailable = this.currentVariant?.available || false;
      swatch.classList.toggle('unavailable', !isAvailable);
    }
  }

  updateMedia(event) {
    console.log("Update media");
    if (this.currentVariant.featured_media.src != undefined) {
      console.log(event.target.closest(".card-wrapper").querySelector(".card__inner .card__media img"));
      console.log(this.currentVariant.featured_media.src);
      event.target.closest(".card-wrapper").querySelector(".card__inner .card__media img").src =
        this.currentVariant.featured_media.src;
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('input[type="radio"]:checked'))
      .map(input => input.value);
    this.dispatchEvent(new CustomEvent('complementary-variant-change', {
      bubbles: true,
      detail: { options: this.options }
    }));
  }

  updateMasterId() {
    if (!this.variantData.length) return;

    // Match only relevant options (ignore empty/null)
    const activeOptions = this.options.filter(opt => !!opt);
    console.log('these are the active options:', activeOptions);
    this.currentVariant = this.variantData.find(variant => {
      // Compare only existing options
      return activeOptions.every((option, index) => {
        const variantOption = variant.options[index] || '';
        return variantOption.trim().toLowerCase() === option.trim().toLowerCase();
      });

    });

    console.log('Selected variant:', this.currentVariant);
  }

  updateFormInputs() {
    if (!this.formId) return;
    const form = document.getElementById(this.formId);
    if (!form) {
      console.error(`Form ${this.formId} not found`);
      return;
    }
    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput && this.currentVariant?.id) {
      variantInput.value = this.currentVariant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const submitButton = form.querySelector('.product-form__submit');
    if (submitButton) {
      const isAvailable = this.currentVariant?.available || false;
      submitButton.disabled = !isAvailable;
      submitButton.querySelector('span').textContent = isAvailable 
        ? 'Add to cart' 
        : 'Sold out';
    }

    const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
    const errorMessage = form.querySelector('.product-form__error-message');
    if (errorWrapper && errorMessage) {
      errorWrapper.hidden = true;
      errorMessage.textContent = '';
    }
  }


  updateSelectionMetadata(event) {
    const target = event.target;
    const selectedValue = target.value;
    if (!target.closest('complementary-variant-selects'|| 'upsell-variant-selects' )) return;

    if (target.type === 'radio') {
      const selectedValueDisplay = target.closest('fieldset')
        ?.querySelector('[data-selected-value]');
      if (selectedValueDisplay) {
        selectedValueDisplay.textContent = selectedValue;
        console.log("Updated selected value display to:", selectedValue);
      }
    }
  }
}

customElements.define('complementary-variant-selects', ComplementaryVariantSelects);
if (!customElements.get('upsell-variant-selects')) {
  class UpsellVariantSelects extends HTMLElement {
    constructor() {
      super();
      this.formId = null;
      this.currentVariant = null;
      this.options = [];
      this.variantData = [];
      this.onVariantChange = this.onVariantChange.bind(this);
      this.handleSwatchHover = this.handleSwatchHover.bind(this);
    }
    connectedCallback() {
      try {
        const scriptContent = this.querySelector('script');
        this.variantData = JSON.parse(scriptContent?.textContent || '[]');
        console.log('variantData: ', this.variantData);
      } catch (error) {
        console.error('Variant data parse error:', error);
      }
      this.formId = this.getAttribute('form-id');
      this.addEventListener('change', this.onVariantChange);
      this.addEventListener('click', (e) => {
        const swatch = e.target.closest('.swatch-option');
        if (!swatch) return;
        const input = swatch.querySelector('input[type="radio"]');
        if (!input) return;
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.updateSelectionMetadata({ target: input });
      });
      this.initializeSwatches();
      this.updateOptions();
      this.updateMasterId();
      this.updateFormInputs();
      this.setupSilentAddToCart();
    }
    setupSilentAddToCart() {
      const form = document.getElementById(this.formId);
      if (!form) return;
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.addToCartSilently(form);
      });
    }
    addToCartSilently(form) {
      if (!form) return;
      const submitButton = form.querySelector('.product-form__submit');
      const spinner = submitButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
      if (submitButton) submitButton.setAttribute('aria-disabled', true);
      const formData = new FormData(form);
      formData.append('sections', 'cart-icon-bubble'); // update sections as needed
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          this.updateCartCount();
          // Auto-update the cart drawer contents without a refresh
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then(response => response.text())
              .then(responseText => {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(responseText, 'text/html');
                const newCartItems = htmlDoc.querySelector('cart-drawer-items');
                if (newCartItems) {
                  document.querySelector('cart-drawer-items').innerHTML = newCartItems.innerHTML;
                }
              })
              .catch(e => console.error(e));
          }
          this.showAddedNotification(submitButton);
        })
        .catch(error => {
          console.error('Error adding product to cart:', error);
          const errorMessageWrapper = form.querySelector('.product-form__error-message-wrapper');
          const errorMessage = form.querySelector('.product-form__error-message');
          if (errorMessageWrapper && errorMessage) {
            errorMessageWrapper.hidden = false;
            errorMessage.textContent = error.message || 'Error adding product to cart';
          }
        })
        .finally(() => {
          if (spinner) spinner.classList.add('hidden');
          if (submitButton) submitButton.removeAttribute('aria-disabled');
        });
    }
    updateCartCount() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartCountBubble = document.querySelector('.cart-count-bubble');
          const cartCount = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
          if (cart.item_count > 0) {
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            } else if (cartCountBubble) {
              cartCountBubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
            } else {
              const cartIcon = document.querySelector('.header__icon--cart');
              if (cartIcon) {
                const bubble = document.createElement('div');
                bubble.className = 'cart-count-bubble';
                bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
                cartIcon.appendChild(bubble);
              }
            }
          }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }
    showAddedNotification(button) {
      if (!button) return;
      const notification = document.createElement('span');
      notification.className = 'added-to-cart-notification';
      notification.textContent = 'Added to cart';
      notification.style.cssText = `
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        background: var(--color-success-background, #E8F6EA);
        color: var(--color-success-text, #0C5C2C);
        padding: 5px 10px;
        border-radius: 4px;
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
        z-index: 5;
        margin-bottom: 5px;
      `;
      button.style.position = 'relative';
      button.appendChild(notification);
      setTimeout(() => notification.style.opacity = '1', 10);
      setTimeout(() => {
        notification.style.opacity = '0';
        setTimeout(() => notification.remove(), 300);
      }, 2000);
    }
    initializeSwatches() {
      this.querySelectorAll('.swatch-option').forEach(swatch => {
        const input = swatch.querySelector('input[type="radio"]');
        swatch.classList.toggle('selected', input?.checked);
      });
    }
    handleSwatchHover(event) {
      const swatch = event.currentTarget;
      const mediaId = swatch.querySelector('input[type="radio"]')?.dataset?.variantMedia;
      if (!mediaId) return;
      const mediaContainer = swatch.closest('.product-card-wrapper')?.querySelector('.media--hover-effect');
      if (!mediaContainer) return;
      const mainImage = mediaContainer.querySelector('.main-product-image');
      if (mainImage) mainImage.classList.remove('active');
      const variantImage = mediaContainer.querySelector(`.variant-image[data-variant-id="${mediaId}"]`);
      if (variantImage) {
        const allVariantImages = mediaContainer.querySelectorAll('.variant-image');
        allVariantImages.forEach(img => img.classList.remove('active'));
        variantImage.classList.add('active');
      }
    }
    disconnectedCallback() {
      const swatchOptions = this.querySelectorAll('.swatch-option');
      swatchOptions.forEach(swatch => {
        swatch.removeEventListener('mouseenter', this.handleSwatchHover);
      });
      this.removeEventListener('change', this.onVariantChange);
      const form = document.getElementById(this.formId);
      if (form) {
        form.removeEventListener('submit', this.addToCartSilently);
      }
    }
    onVariantChange(event) {
      if (!event.target.matches('input[type="radio"]')) return;
      const group = event.target.closest('.swatch-options');
      if (group) {
        group.querySelectorAll('.swatch-option').forEach(swatch => {
          swatch.classList.remove('selected');
        });
        event.target.closest('.swatch-option').classList.add('selected');
      }
      this.updateOptions();
      this.updateMasterId();
      this.updateFormInputs();
      this.updateSelectionMetadata(event);
      const swatch = event.target.closest('.swatch-option');
      if (swatch) {
        const isAvailable = this.currentVariant?.available || false;
        swatch.classList.toggle('unavailable', !isAvailable);
      }
    }
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('input[type="radio"]:checked'))
        .map(input => input.value);
      this.dispatchEvent(new CustomEvent('upsell-variant-change', { bubbles: true, detail: { options: this.options } }));
    }
    updateMasterId() {
      if (!this.variantData.length) return;
      const activeOptions = this.options.filter(opt => !!opt);
      this.currentVariant = this.variantData.find(variant => {
        return activeOptions.every((option, index) => {
          const variantOption = variant.options[index] || '';
          return variantOption.trim().toLowerCase() === option.trim().toLowerCase();
        });
      });
    }
    updateFormInputs() {
      if (!this.formId) return;
      const form = document.getElementById(this.formId);
      if (!form) {
        console.error(`Form ${this.formId} not found`);
        return;
      }
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput && this.currentVariant?.id) {
        variantInput.value = this.currentVariant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const submitButton = form.querySelector('.product-form__submit');
      if (submitButton) {
        const isAvailable = this.currentVariant?.available || false;
        submitButton.disabled = !isAvailable;
        submitButton.querySelector('span').textContent = isAvailable ? 'Add to cart' : 'Sold out';
      }
      const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
      const errorMessage = form.querySelector('.product-form__error-message');
      if (errorWrapper && errorMessage) {
        errorWrapper.hidden = true;
        errorMessage.textContent = '';
      }
    }
    updateSelectionMetadata(event) {
      const target = event.target;
      const selectedValue = target.value;
      if (!target.closest('upsell-variant-selects')) return;
      if (target.type === 'radio') {
        const selectedValueDisplay = target.closest('fieldset')?.querySelector('[data-selected-value]');
        if (selectedValueDisplay) {
          selectedValueDisplay.textContent = selectedValue;
        }
      }
    }
  }
  customElements.define('upsell-variant-selects', UpsellVariantSelects);
}